import React, {useEffect, useRef, useState} from 'react';
import {StyleSheet} from 'react-native';
import {View} from 'react-native';
import Header from './components/Header';
import Swiper from 'react-native-web-swiper';
import {useTranslation} from 'react-i18next';
import Slider from './components/learning-slider/LearningSlider';
import {windowWidth} from '../../constants';
import SVG from '../../imports/svg';
import {selecetvehivletype} from '../../selectors/Vehicle';
import {useDispatch, useSelector} from 'react-redux';
import {useStopwatch} from 'react-timer-hook';
import {showSheet} from '../../actions/SheetActions';

const TripLearning = () => {
  const swiperRef = useRef(null);
  const {t} = useTranslation();
  const {vehicle} = useSelector(state => selecetvehivletype(state));
  const [index, setIndex] = useState(2);
  const dispatch = useDispatch();

  const slides =
    vehicle?.type == 'Bike'
      ? [
          {
            key: '1',
            title: t('end_trip'),
            text: t('motor_end_trip_learning'),
            image: 'startbike2',
          },
          {
            key: '2',
            title: t('start_trip'),
            text: t('motor_start_trip_learning'),
            image: 'startbike3',
          },
          {
            key: '3',
            title: t('sufficient_charge'),
            text: t('motor_sufficient_charge_learning'),
            image: 'startbike4',
          },
          {
            key: '4',
            title: t('hat'),
            text: t('hat_learning'),
            image: 'startbike1',
          },
        ]
      : [
          {
            key: '1',
            title: t('end_trip'),
            text: t('bike_end_trip_learning'),
            image: 'startbicycle1',
          },
          {
            key: '2',
            title: t('start_trip'),
            text: t('bike_start_trip_learning'),
            image: 'startbicycle2',
          },
          {
            key: '3',
            title: t('sufficient_charge'),
            text: t('bike_sufficient_charge_learning'),
            image: 'startbike4',
          },
        ];

  useEffect(() => {
    dispatch(
      showSheet({
        sheetId: '',
      }),
    );
    setTimeout(() => {
      if (index !== 0 && swiperRef.current) {
        swiperRef.current.goToPrev();
      }
    }, 2000);
    setTimeout(() => {
      if (index !== 0 && swiperRef.current) {
        swiperRef.current.goToPrev();
      }
    }, 4000);
    setTimeout(() => {
      if (index !== 0 && swiperRef.current) {
        swiperRef.current.goToPrev();
      }
    }, 6000);
  }, []);

  return (
    <View style={styles.container}>
      <View style={styles.backgroundContainer}>
        <SVG
          name={'background'}
          width={windowWidth}
          height={windowWidth * 0.68}
        />
      </View>
      <Header />
      <Swiper
        ref={swiperRef}
        innerContainerStyle={{
          paddingBottom: 105,
        }}
        from={slides.length - 1}
        minDistanceForAction={0.1}
        onIndexChanged={index => setIndex(index)}
        gesturesEnabled={() => true}
        controlsProps={{
          dotsTouchable: true,
          prevPos: false,
          nextPos: false,
          DotComponent: ({isActive}) => {
            return (
              <View
                style={[
                  styles.dot,
                  {backgroundColor: isActive ? '#F34F42' : '#EAEAEA'},
                ]}
              />
            );
          },
        }}>
        {slides.map(({key, ...otherProps}) => (
          <Slider
            key={key}
            end={1}
            id={key}
            length={slides.length}
            swiperRef={swiperRef}
            {...otherProps}
          />
        ))}
      </Swiper>
    </View>
  );
};

export default TripLearning;

const styles = StyleSheet.create({
  dot: {
    width: 8,
    height: 8,
    borderRadius: 8,
    marginHorizontal: 3,
  },
  container: {
    flex: 1,
  },
  backgroundContainer: {
    position: 'absolute',
    top: 10,
    zIndex: -10,
  },
});
